import React from "react";
import { Controller } from "react-hook-form";
import styled, { useTheme } from "styled-components";
import { TextVariant, TypographyNew } from "../typography/typography";
import Checkbox from "./Checkbox";

type CheckboxControlledProps = {
  fieldName: string;
  defaultValue?: boolean;
  control: any;
  errorText?: string;
  activeColor?: string;
  passiveColor?: string;
  label?: string;
  labelTrue?: string;
  labelFalse?: string;
  className?: string;
  disabled?: boolean;
  disableChange?: boolean;
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const CheckboxControlled = ({
  fieldName,
  defaultValue,
  control,
  label,
  activeColor,
  className,
  disabled,
}: CheckboxControlledProps): JSX.Element => {
  const theme = useTheme();
  const color = activeColor ?? theme.colors.primary1;
  return (
    <div className={className}>
      {label && (
        <TypographyNew marginBottom="10px" variant={TextVariant.body1}>
          {label}
        </TypographyNew>
      )}
      <Controller
        name={fieldName}
        control={control}
        defaultValue={defaultValue ? defaultValue : false}
        render={({ field: { onChange, value } }) => {
          return (
            <Wrapper>
              <Checkbox
                color={color}
                checked={value}
                onChange={onChange}
                disabled={disabled}
                id={fieldName}
              />
            </Wrapper>
          );
        }}
      />
    </div>
  );
};

export default CheckboxControlled;
